
<div>
  <JobPostScheduleRegular v-if="showScheduleRegular" />
  <OneTimeSchedule :draft="draft" v-if="showScheduleOneTime" />
  <JobPostScheduleOccasional :draft="draft" v-if="showScheduleOccasional" />
  <JobPostScheduleNanny v-if="showScheduleNanny" />
</div>
